const jobTypeReducer = (state = [], action) => {
    switch (action.type) {
    case 'UPDATE_SELECTED_JOB_TYPE':
        return action.payload;
    default:
        return state;
    }
};

export default jobTypeReducer;